import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { MatButton } from '@angular/material/button';
import { NotificationModel } from '@shared/services/notifications/notifications.model';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButton],
})
export class NotificationComponent {
  public readonly notification = inject<NotificationModel>(MAT_SNACK_BAR_DATA);
  private readonly _snackBar = inject<MatSnackBarRef<NotificationModel>>(MatSnackBarRef);

  public close() {
    this._snackBar.dismiss();
  }
}
